import React from "react";
import { ButtonCta } from "@/components";
import { fontSizes } from "@/constants/constants";

const srcOf = (img) => (typeof img === "string" ? img : img?.src || "");

function VideoContent({ title, text1, image, reverse = false, classStyle, eyebrow, btnText }) {
  const img = srcOf(image);
  return (
    <section className={`relative w-full overflow-hidden bg-paper py-16 md:py-20 ${classStyle || ""}`}>
      <div
        className={`mx-auto flex max-w-[1350px] flex-col items-center gap-10 px-5 lg:gap-14 ${
          reverse ? "lg:flex-row-reverse" : "lg:flex-row"
        }`}
      >
        {/* Text */}
        <div className="w-full text-center lg:w-1/2 lg:text-left">
          {eyebrow && (
            <span className="eyebrow flex items-center justify-center gap-3 text-gold-deep lg:justify-start">
              <span className="h-px w-8 bg-gold/70" />
              {eyebrow}
            </span>
          )}
          {title && (
            <h2 className={`mt-4 font-display font-semibold text-ink ${fontSizes.text_5_xl}`}>{title}</h2>
          )}
          <div className={`mt-5 leading-relaxed text-ink-soft ${fontSizes.base}`}>{text1}</div>
          {btnText && (
            <div className="mt-8 flex justify-center lg:justify-start">
              <ButtonCta buttonText={btnText} classStyle="text-white bg-brand-600 hover:bg-brand-700 h-12" />
            </div>
          )}
        </div>

        {/* Image */}
        <div className="flex w-full justify-center lg:w-1/2">
          <div className="relative w-full max-w-xl">
            <div className="absolute -inset-3 rounded-[1.8rem] border border-gold/25" />
            <div className="absolute -inset-3 rounded-[1.8rem] bg-gradient-to-br from-brand-100/40 to-gold-soft/20 blur-lg" />
            <div className="relative z-10 overflow-hidden rounded-[1.4rem] shadow-editorial ring-1 ring-black/10">
              <img loading="lazy" decoding="async"
                src={img}
                alt={typeof title === "string" ? title : "Our vision"}
                className="aspect-[4/3] w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoContent;
